<template>
  <b-card class="rounded-lg">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Lab Results
        </h4>

        <div class="d-flex align-items-center">
          <b-button size="sm" variant="link" class="p-0">
            <feather-icon
              icon="PlusCircleIcon"
              size="20"
            />
          </b-button>

          <!-- <UserViewActionCard :user-data="consultationData" @update-user-data="$emit('update-user-data', $event)"></UserViewActionCard> -->
        </div>
      </div>
    </template>
    

    <div class="card-body">
      <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="d-flex align-items-center">
          <p>
            <feather-icon icon="FileTextIcon" size="25" class="text-primary" />
          </p>
          <h4 class="ml-1 text-dark">X-Ray - {{ consultationData.full_name }}</h4>
        </div>

        <h4 class="text-muted">06/01/2024</h4>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="d-flex align-items-center">
          <p>
            <feather-icon icon="FileTextIcon" size="25" class="text-primary" />
          </p>
          <h4 class="ml-1 text-dark">Allergen-specific lgE</h4>
        </div>

        <h4 class="text-muted">06/01/2024</h4>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="d-flex align-items-center">
          <p>
            <feather-icon icon="FileTextIcon" size="25" class="text-primary" />
          </p>
          <h4 class="ml-1 text-dark">Nasal Endoscopy</h4>
        </div>

        <h4 class="text-muted">06/01/2024</h4>
      </div>

      <div class="d-flex align-items-center justify-content-between mb-1">
        <div class="d-flex align-items-center">
          <p>
            <feather-icon icon="FileTextIcon" size="25" class="text-primary" />
          </p>
          <h4 class="ml-1 text-dark">CT - {{ consultationData.full_name }}</h4>
        </div>

        <h4 class="text-muted">06/01/2024</h4>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

// import UserViewActionCard from "./PatientOverviewActionCard.vue";

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    // UserViewActionCard,
  },
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  setup() {},
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
